
import React from "react";
import { ForecastTabContentProps } from "./types";
import { OperationalProjectCard } from "./OperationalProjectCard";
import { PreRevenueProjectCard } from "./PreRevenueProjectCard";

export function ForecastTabContent({ models, isPreRevenue, onViewData }: ForecastTabContentProps) {
  const filteredModels = models.filter(model => model.isPreRevenue === isPreRevenue);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {filteredModels.map(model => 
        isPreRevenue ? (
          <PreRevenueProjectCard 
            key={model.id} 
            model={model} 
            onViewData={onViewData} 
          />
        ) : (
          <OperationalProjectCard 
            key={model.id} 
            model={model} 
            onViewData={onViewData} 
          />
        )
      )}
    </div>
  );
}
